<template>
  <div class="product-wrap">
    <div class="outer">
      <div class="content">
        <video data-v-1740c1c8="" controls="controls" ><source data-v-1740c1c8="" src="//fs.lizheng.design/static/home.mp4" type="video/mp4">
        您的浏览器不支持 video 标签。
      </video>
        <img v-for="item in content" v-lazy="item" :key="item" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    content() {
      const glb = [];
      for (let i = 0; i <=1; i++) {
        glb[i] = require(`@/assets/images/products/video${i+1}.jpg`);
      }
      return glb;
    }
  }
};
</script>
<style lang="stylus" scoped>
.product-wrap {
  margin-top: -2.5em;
  background-color: #f2f2f2;

  .outer {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    .content {
      width: 100%;

      img {
        display: block;
        margin: 0 auto;
        width: 80%;
        max-width: 1024px;
      }
      video {
        display: block;
        margin: 0 auto;
        width: 80%;
        max-width: 1024px;
      }
    }
  }
}
</style>
